import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL + "/api";

const client = axios.create({ baseURL: API, withCredentials: true });

export default client;
